// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"style_buttonIcon__3tND9","buttonAsLink":"style_buttonAsLink__3DBm9","vehiclesDescription":"style_vehiclesDescription__1uVfq"};